import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import NotifyList from '../../_SharedWorkflow/Notify/List';
import NotifyCreate from '../../_SharedWorkflow/Notify/Create';
import NotifyDetail from '../../_SharedWorkflow/Notify/Detail';

const defaultFields = {
    Subject: { visible: false, label: '', required: false },
    Type: { visible: false, label: '', required: false },
    ResponseRequiredDate: { visible: false, label: '', required: false },
    Details: { visible: false, label: '', required: false },
}
const defaultReplyFields = {
    ReplyStatus: { visible: false, label: '', required: false },
    ReplyComment: { visible: false, label: '', required: false },
}


///ALL FIELDS ARE DECIDED WITHIN THE getFields FUNCTION
///THE getFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign fields to workflowItem
export const getFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid, globalResources, contract) => {
    const fields = { ...defaultFields };
    const workflowItem = workflowsQA[wfid];
    let clauses = workflowItem.clauses;
    if (!clauses) {
        if (wfid === 4 && placeholdersQA.InstructionTypes) {
            clauses = placeholdersQA.InstructionTypes.values.filter(item => item.isActive === true);
        }
        else if (wfid === 56 && placeholdersQA.ClientInstructionTypes) {
            clauses = placeholdersQA.ClientInstructionTypes.values.filter(item => item.isActive === true);
        }
        else if (wfid === 61 && placeholdersQA.SupervisorInstructionTypes) {
            clauses = placeholdersQA.SupervisorInstructionTypes.values.filter(item => item.isActive === true);
        }
    }


    fields.Subject = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.SUBJECT"], required: true };
    fields.Type = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.TYPE"], required: true };
    fields.Type.clauses = clauses;
    if (workflowItem.replyEnabled) {
        fields.ResponseRequiredDate = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.RESPONSE_REQUIRED"], required: false };
    }
    fields.Details = { visible: true, label: workflowItem.notificationName, required: true };

    return fields;
}
///ALL REPLY FIELDS ARE DECIDED WITHIN THE getReplyFields FUNCTION
///THE getReplyFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign replyFields to workflowItem
export const getReplyFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid) => {
    const replyFields = { ...defaultReplyFields };
    const workflowItem = workflowsQA[wfid];

    let replyOptions = workflowItem.replyOptions;
    if (!replyOptions && placeholdersQA.ReplyOptions) {
        replyOptions = placeholdersQA.ReplyOptions.values.filter(item => item.isActive === true);
    }

    replyFields.ReplyStatus = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.STATUS"], required: true };
    replyFields.ReplyStatus.replyOptions = replyOptions;
    replyFields.ReplyComment = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.COMMENTS"], required: true };
    return replyFields;
}
class InstructionRouter extends React.Component {
    constructor(props) {
        super(props);
        if (props.mode === 'PM') {
            this.notificationType = 'Instruction';
            this.documentType = 'Document143pm';
        }
        else if (props.mode === 'CLIENT') {
            this.notificationType = 'InstructionClient';
            this.documentType = 'DocumentInstructionClient';
        }
        else if (props.mode === 'SUPERVISOR') {
            this.notificationType = 'InstructionSupv';
            this.documentType = 'DocumentInstructionSupv';
        }


        this.notifyingParty = props.workflowItem.notifyingParty;
        this.replyingParty = props.workflowItem.replyingParty;



        this.notificationName = props.workflowItem.notificationName;
        this.abbreviation = props.workflowItem.abbreviation;
    }
    shouldComponentUpdate() {
        return false;
    }
    render() {
        const { workflowItem } = this.props;

        return (
            <>
                <Routes caseSensitive>
                    <Route
                        path={workflowItem.config.paths.list}
                        exact
                        element={<NotifyList
                            {...this.props}
                            title={this.notificationName}
                            abbreviation={this.abbreviation}
                            notificationType={this.notificationType}
                        />}

                    />
                    <Route
                        path={workflowItem.config.paths.create}
                        exact
                        element={
                            workflowItem.userFilters.mainNotice.createAllowed ? (
                                <NotifyCreate
                                    {...this.props}

                                    title={this.notificationName}
                                    clauses={this.clauses}
                                    notificationType={this.notificationType}
                                />) : (
                                <Navigate replace to={workflowItem.paths.defaultPath} />
                            )
                        }
                    />
                    <Route
                        path={'/:notificationid/*'}
                        exact
                        element={<NotifyDetail
                            {...this.props}
                            clauses={this.clauses}
                            title={this.notificationName}
                            abbreviation={this.abbreviation}
                            notificationType={this.notificationType}
                            documentType={this.documentType}
                            notifyUserFilter={workflowItem.notifyUserFilter}
                        />}
                    />
                </Routes>
            </>
        );
    }
}



export default (InstructionRouter);